import { FilterKeyConfig } from 'src/utils/filters/parseUrlFilters';

export const filterKeyMap: FilterKeyConfig[] = [
  // Strings
  { key: 'acids', type: 'string', isArray: true },
  { key: 'aircraftCategories', type: 'string', isArray: true },
  { key: 'aircraftTypes', type: 'string', isArray: true },
  { key: 'airlines', type: 'string', isArray: true },
  { key: 'tailNumbers', type: 'string', isArray: true },
  { key: 'airportIds', type: 'string', isArray: true },
  { key: 'remoteAirportIds', type: 'string', isArray: true },
  { key: 'runwayNames', type: 'string', isArray: true },
  { key: 'operationTypes', type: 'string', isArray: true },
  { key: 'operatorCategories', type: 'string', isArray: true },
  // Numbers
  { key: 'limitToIds', type: 'number', isArray: true },
  { key: 'gateIds', type: 'number', isArray: true },
  // Dates
  { key: 'timePeriod', type: 'timeRange', isArray: false },
  // position
  { key: 'position', type: 'position', isArray: false },
  // Boolean
  { key: 'hasInfringements', type: 'boolean', isArray: false },
  {
    key: 'correlated',
    type: 'combined',
    isArray: true,
    children: [
      { key: 'hasComplaints', displayName: 'Complaints', type: 'boolean', isArray: false },
      { key: 'hasCorrelations', displayName: 'Correlations', type: 'boolean', isArray: false },
      { key: 'hasCcoInfringements', displayName: 'CCO', type: 'boolean', isArray: false },
      { key: 'hasCdoInfringements', displayName: 'CDO', type: 'boolean', isArray: false },
      { key: 'hasCorridorInfringements', displayName: 'Corridor', type: 'boolean', isArray: false },
      { key: 'hasCurfewInfringements', displayName: 'Curfew', type: 'boolean', isArray: false },
      {
        key: 'hasExclusionInfringements',
        displayName: 'Exclusion',
        type: 'boolean',
        isArray: false,
      },
      { key: 'hasGateInfringements', displayName: 'Gate', type: 'boolean', isArray: false },
      {
        key: 'hasMinHeightInfringements',
        displayName: 'MinHeight',
        type: 'boolean',
        isArray: false,
      },
      { key: 'hasNoiseEvents', displayName: 'NoiseEvents', type: 'boolean', isArray: false },
      {
        key: 'hasNoiseInfringements',
        displayName: 'Noise',
        type: 'boolean',
        isArray: false,
      },
    ],
  },
];

export const INFRINGEMENTS_QUERY_FIRST = 1000; // Default first value for infringements queries
